<template>
  <div class="app-navbar primary-bg container-fluid">
    <link
      :href="themeCssUrl('/style.css')"
      rel="stylesheet"
    >

    <div class="row header">
      <div class="container">
        <div class="row">
          <div class="col-xs-6 logo-box">
            <a :href="baseUrl()">
              <img
                :src="themeUrl('logo.png')"
                alt="Apex Logo"
              >
            </a>
          </div>
          <div
            v-if="currentUser.id"
            class="col-xs-6"
          >
            <div class="logout-box text-right">
              <div><a :href="baseUrl('logout')"><strong>LOG OUT</strong></a></div>
              <div class="greeting">
                Good Bye
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row main-nav secondary-bg">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div
              v-if="currentUser.id"
              class="context-nav"
            >
              <ul class="nav nav-pills">
                <li
                  v-if="serviceLevelPaid"
                  :class="{active: '' === currentUrl.toString() || !currentUrl}"
                >
                  <a :href="baseUrl()">Inbox</a>
                </li>
                <li :class="{active: 'vehicles' === currentUrl.toString()}">
                  <a :href="baseUrl('vehicles')">Vehicles</a>
                </li>
                <li :class="{active: 'profile' === currentUrl.toString()}">
                  <a :href="baseUrl('profile')">Profile</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentUrl: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" type="text/scss">
    @import "resources/assets/sass/variables";

    #app {
        .app-navbar {
            .header {
                height: 100px;
                .logo-box {
                    margin-top: 20px;
                    img {
                        max-height: 60px;
                        margin-right: 20px;
                    }
                }
                .logout-box {
                    line-height: 1.2;
                    margin-top: 20px;
                    a {
                        font-size: 1.4em;
                        font-weight: 900;
                        color: $secondary-light
                    }
                    .greeting {
                        font-style: italic;
                        font-weight: 300;
                    }
                }
            }
            .main-nav {
                height: 40px;
                ul.nav-pills {
                    li {
                        a {
                            color: $white;
                            border-radius: 0;
                            &:hover {
                                background-color: $secondary-light;
                            }
                        }
                        &.active {
                            & > a {
                                background-color: $secondary-light;
                            }
                        }
                        & > ul {
                            background-color: $secondary;
                            border-radius: 0;
                            margin-top: 0;
                            border: none;
                            padding: 0;
                        }
                    }
                }
            }
        }
    }
</style>
